module.exports = __webpack_public_path__ + "img/delos-logo.f1b9d22f.png";